import { parse } from 'url';

export default function getReferenceAttachmentDisplayUrl(
    referenceAttachmentOpenUrl: string,
    attachLongPathName: string
): string {
    const hostName = referenceAttachmentOpenUrl
        ? parse(referenceAttachmentOpenUrl)?.hostname
        : null;
    return hostName != null ? hostName : attachLongPathName;
}
